// This icon file is generated automatically.
var PtoLockOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 32 32", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M26 14.5h-2.13v-7a4 4 0 00-4-4h-7.75a4 4 0 00-4 4v7H6a1 1 0 00-1 1v12a1 1 0 001 1h20a1 1 0 001-1v-12a1 1 0 00-1-1zm-15.63-7c0-.97.79-1.75 1.76-1.75h7.74c.97 0 1.75.78 1.75 1.75v7H10.38v-7zm14.38 18.75H7.25v-9.5h17.5v9.5zm-9.63-4.34v1.65c0 .14.12.25.26.25h1.24c.14 0 .25-.11.25-.25v-1.65a1.5 1.5 0 10-1.75 0z", "fill-rule": "nonzero" } }] }, "name": "pto-lock", "theme": "outlined" };
export default PtoLockOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PtoLockOutlined.js
// module id = 3917
// module chunks = 0